import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Link } from '@design-system/Link';
import { List, ListItem } from '@design-system/List';
import { STUDIES_PATH, VIE_CHAT_PATH } from '@/constants/paths';

export type AccountManagementPageStudiesSectionProps =
  React.ComponentProps<'div'>;

const STUDY_SECTIONS = [
  {
    label: 'My Studies',
    to: STUDIES_PATH,
  },
  {
    label: 'Chat with Vie',
    to: VIE_CHAT_PATH,
  },
];

const renderedStudySections = STUDY_SECTIONS.map((section, index) => (
  <ListItem asChild key={index}>
    <Link to={section.to}>{section.label}</Link>
  </ListItem>
));

export const AccountManagementPageStudiesSection = ({
  className,
}: AccountManagementPageStudiesSectionProps) => {
  return (
    <div className={cn('flex flex-col', className)}>
      <span className="typography-h2 text-primary mb-6">My Studies</span>

      <Card className="overflow-hidden">
        <List>{renderedStudySections}</List>
      </Card>
    </div>
  );
};
